import Status from "src/pages/SelfOnboarding/Status";
import { SELF_ONBOARDING_PATHS } from "src/consts/paths";
import { SELF_ONBOARDING_ROUTES } from "src/consts/routes";
import { Route, Routes, useLocation } from "react-router-dom";
import Compatibility from "src/pages/SelfOnboarding/Compatibility";
import SelfOnboardingProgressBar from "../SelfOnboardingProgressBar";
import { Box, Container, Grid, Stack, useTheme } from "@mui/material";
import SiteAuthenticationFooter from "../Footer/SiteAuthenticationFooter";
import BrandItemThemeChanger from "../BrandIconThemeChanger/BrandIconThemeChanger";

const SelfOnboarding = () => {
  const theme = useTheme();
  const { pathname } = useLocation();

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
      }}
    >
      <Container
        sx={{
          marginTop: { xs: 0, sm: 12 },
          flexGrow: 1,
          justifyContent: "space-between",
          alignContent: "space-between",
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stack gap="50px">
              <Box
                sx={{
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <BrandItemThemeChanger />
              </Box>
              {SELF_ONBOARDING_PATHS.includes(pathname) && (
                <SelfOnboardingProgressBar />
              )}
            </Stack>
          </Grid>

          <Stack
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              width: "100%",
              py: 2,
            }}
          >
            <BrandItemThemeChanger />
          </Stack>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={<Compatibility />}
                path={SELF_ONBOARDING_ROUTES.COMPATIBILITY}
              />
              <Route
                element={<Status />}
                path={SELF_ONBOARDING_ROUTES.STATUS}
              />{" "}
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <SiteAuthenticationFooter />
    </Stack>
  );
};

export default SelfOnboarding;
